import { useMemo } from 'react';

import { UseBaseTable } from 'hooks/useBaseTable';
import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryProjectScoreCardsSummary } from 'api/queries/getProjectScoreCardsSummary';

import { FilterNames, getFiltersData } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';
import { prepareVersionSelectTitle } from 'components/common/TreeProgramFilter/VersionSelect/versionSelect.utils';

export type UseProjectScorecardsProvider = ReturnType<typeof useProjectScorecardsProvider>;

interface Props {
    componentKey: string;
    widgetId?: string;
    globalFilterData: any;
    localFilters: any;
    table: UseBaseTable['table'];
}

export const useProjectScorecardsProvider = ({ widgetId, globalFilterData, localFilters }: Props) => {
    const isInPinboard = Boolean(widgetId);
    const source = isInPinboard ? localFilters : { ...globalFilterData };
    const title = 'My Projects';
    const subTitleForExport = `${title}, ${prepareVersionSelectTitle()}`;

    const filters = useMemo(
        () =>
            getFiltersData({
                [FilterNames.TAG_PORTFOLIO_BOARD]: source?.programTags?.map((item) => item.value),
            }),
        [source],
    );

    const getProjectScoreCardsSummaryPayload = {
        filter: {
            filters,
        },
    };

    const getProjectScoreCardsSummary = useQueryProjectScoreCardsSummary(getProjectScoreCardsSummaryPayload);

    // create pill data for PinboardWidgetPills component
    const pillsData = {
        programTags: source?.programTags?.map((item) => item.label),
    };

    const { pillsList: pills } = useGlobalFiltersHook({ widgetId, source: pillsData });

    return {
        ui: {
            state: {
                programTags: source?.programTags,
            },
            subTitleForExport,
            pills,
            isInPinboard,
        },
        api: {
            getProjectScoreCardsSummary: {
                instance: getProjectScoreCardsSummary,
                payload: getProjectScoreCardsSummaryPayload,
            },
        },
    };
};
